import React, {useEffect, useState} from "react";
import {getPerformances} from "../../lib/api";
import ProfileHeader from "../Headers/ProfileHeader";
import PerformanceEdit from "./PerformanceEdit";
import {Button} from "react-bootstrap";

function ListPerformances(props: { performances: any, editPerformance: any }) {
  const {performances, editPerformance} = props;
  const list = performances.map(function (performance: any) {
    return (
      <li key={`performance-${performance.id}`}>
        <a href="#"
           onClick={() => {
             editPerformance(performance);
             return false;
           }}
        >{performance.name}</a>
      </li>
    );
  });
  return <ul>{list}</ul>;
}

function Performances(props: { cognitoUser: any }) {
  const {cognitoUser} = props;
  const [performances, setPerformances] = useState([]);
  const [performance, setPerformance] = useState({name: "", url: ""});
  const [showEdit, setShowEdit] = useState(false);

  useEffect(() => {
      refreshPerformances();
    }, []
  )

  function refreshPerformances() {
    getPerformances().then(response => {
      if (response.ok) {
        response.json().then(json => {
          setPerformances(json.performances);
        });
      }
    })
  }

  function addPerformance() {
    setPerformance({name: "", url: ""})
    setShowEdit(true);
  }

  function editPerformance(performance: any) {
    setPerformance(performance);
    setShowEdit(true);
  }

  function onHideEdit() {
    setShowEdit(false);
  }

  return (
    <>
      <ProfileHeader cognitoUser={cognitoUser} title="Performances" linkToHome="/home"/>
      <section className="container main library p-4 rounded">
        <div className="row">
          <div className="col pb-4 text-center instructions">
            Performances are in alpha and coming soon...
          </div>
        </div>
        <div className="row">
          <div className="col text-center">
            <ListPerformances performances={performances} editPerformance={editPerformance}/>
          </div>
        </div>
        <div className="row">
          <div className="col pt-4 text-center">
            <Button onClick={addPerformance}>Add Performance</Button>
          </div>
        </div>
        <PerformanceEdit performance={performance}
                         loadData={refreshPerformances}
                         show={showEdit}
                         onHide={onHideEdit}
        />
      </section>
    </>
  );

}

export default Performances;
